import { wagesIds } from "../constants";
import { allotAmountRanges, numberChildMultiplier } from "../constants/monitor";

export const calculateGrossIncome = (parent) => {

  const {grossIncome,hours,frequencyIncome} = parent;
  let grossIncomeAmount = 0;

  switch (frequencyIncome) {
      case wagesIds.HOURLY:
          grossIncomeAmount = (grossIncome * hours * 52) / 12;
          break;
      case wagesIds.WEEKLY:
          grossIncomeAmount = (grossIncome * 52) / 12;
          break;
      case wagesIds.BIWEEKLY:
          grossIncomeAmount = (grossIncome * 26) / 12;
          break;
      case wagesIds.SEMIMONTHLY:
          grossIncomeAmount = (grossIncome * 24) / 12;
          break;
      case wagesIds.MONTHLY:
          grossIncomeAmount = grossIncome;
          break;
      case wagesIds.ANUALLY:
          grossIncomeAmount = grossIncome / 12;
          break;
      case wagesIds.YEARTODATE:

          const currentDate = new Date();
          currentDate.setHours(0, 0, 0, 0);
          const firstDayYear = new Date(currentDate.getFullYear(), 0, 1);
          const elapsedDays = ((currentDate.getTime() - firstDayYear.getTime()) / (1000*60*60*24)) + 1;

          grossIncomeAmount = ((grossIncome / elapsedDays) * 365) / 12;
          break;
      default:
          break;
  }

  return grossIncomeAmount;
}

export const calculateDisponsableIncome = (parent1, parent2) => {
  const grossIncomeAmountParent1 = calculateGrossIncome(parent1);
  const grossIncomeAmountParent2 = calculateGrossIncome(parent2);

  const disponsableIncomeParent1 = grossIncomeAmountParent1 - grossIncomeAmountParent1*(parent1.taxes.federalRate + parent1.taxes.stateRate)/100;
  const disponsableIncomeParent2 = grossIncomeAmountParent2 - grossIncomeAmountParent2*(parent2.taxes.federalRate + parent2.taxes.stateRate)/100; 
  
  const totalNetDisponsable = disponsableIncomeParent1 + disponsableIncomeParent2;
  const higherDisponsableIncome = Math.max(disponsableIncomeParent1,disponsableIncomeParent2);

  return {
      disponsableIncomeParent1, 
      disponsableIncomeParent2,
      totalNetDisponsable, 
      higherDisponsableIncome
  };
}

export const calculateAverageTimeWithChildren = (childrens,equalTimeParents,childrensCount) => {
  
  const averageTimeParents = (equalTimeParents || childrensCount===1) 
    ? [childrens[0].timeParent1,childrens[0].timeParent2]
    : childrens.slice(0,childrensCount).reduce(
        (acc, cValue) => [acc[0]+cValue.timeParent1,acc[1]+cValue.timeParent2],
        [0.00,0.00]
      );
  return {
    averageTimeParent1: averageTimeParents[0]/childrensCount,
    averageTimeParent2: averageTimeParents[1]/childrensCount
  }
}

export const calculateAllotAmount = (totalNetDisponsable) => {
  let allotAmount = 0.00;
  
  if (totalNetDisponsable > 0) {
      if (totalNetDisponsable >= allotAmountRanges.RANGE1_MIN && totalNetDisponsable <= allotAmountRanges.RANGE1_MAX) {
          allotAmount = (0.20 + totalNetDisponsable/16000);
      } else if(totalNetDisponsable >= allotAmountRanges.RANGE2_MIN && totalNetDisponsable <= allotAmountRanges.RANGE2_MAX){
          allotAmount = 0.25;
      } else if( totalNetDisponsable >= allotAmountRanges.RANGE3_MIN && totalNetDisponsable <= allotAmountRanges.RANGE3_MAX){
          allotAmount = (0.10 + 1000/totalNetDisponsable);
      } else if( totalNetDisponsable >= allotAmountRanges.RANGE4_MIN && totalNetDisponsable <= allotAmountRanges.RANGE4_MAX){
          allotAmount = (0.12 + 800/totalNetDisponsable);
      }
  } else {
      return 0;
  }

  return allotAmount;
}

export const calculateKvalue = (allotAmount,averageTime) => {
  let kValues = {
      parent1: (
          averageTime.averageTimeParent1 <= 50.00 
          ? (1 + averageTime.averageTimeParent1/100) * allotAmount 
          : (2 - averageTime.averageTimeParent1/100) * allotAmount
      ),
      parent2: (
          averageTime.averageTimeParent2 <= 50.00 
          ? (1 + averageTime.averageTimeParent2/100) * allotAmount 
          : (2 - averageTime.averageTimeParent2/100) * allotAmount
      )
  }

  return kValues;
}

export const calculateCS = (parentsInfo,childrensInfo) => {

  const { parents, equalTimeParents } = parentsInfo;
  const { childrens, childrensCount } = childrensInfo;

  const CM = numberChildMultiplier[childrensCount];
  const TN = calculateDisponsableIncome(parents[0], parents[1]);
  const H = calculateAverageTimeWithChildren(childrens,equalTimeParents,childrensCount);
  const AA = calculateAllotAmount(TN.totalNetDisponsable);
  const K = calculateKvalue(AA, H);

  const results = {
      CS: {
          parent1: (K.parent1 * (TN.higherDisponsableIncome - (H.averageTimeParent1/100) * TN.totalNetDisponsable)) * CM,
          parent2: (K.parent2 * (TN.higherDisponsableIncome - (H.averageTimeParent2/100) * TN.totalNetDisponsable)) * CM
      },
      variables: {
          CM : CM,
          TN : TN,
          H: H,
          K: K,
      }
  }

  return results; 
}

export const formatParent = (item) => {
  let infoParent = JSON.parse(JSON.stringify(item));
  const parentIncome = {
    timeUnit: item.frequencyIncome,
    amount: (item.grossIncome !== '') ? item.grossIncome : 0,
    params: {
      date: new Date(),
      hours: item.hours
    }
  }
  infoParent.grossIncome = JSON.parse(JSON.stringify(parentIncome));

  return infoParent;
}

export const formatChildrens = (childrens, count, equalTimeParents) =>{
  let infoChildrens = [];


  childrens.slice(0,count).forEach((child) => {
    const info = {
      name: child.name,
      timeParent1: {
        timeUnit: 'PERCENT',
        time: equalTimeParents ? childrens[0].timeParent1 : child.timeParent1
    },
    timeParent2: {
        timeUnit: 'PERCENT',
        time: equalTimeParents ? childrens[0].timeParent2 : child.timeParent2
    }
    };
    infoChildrens.push(JSON.parse(JSON.stringify(info)));
})


  return infoChildrens;
}

export const formatData = (parentsInfo,childrensInfo) => {
  let data = {
    parent1: formatParent(parentsInfo.parents[0]),
    parent2: formatParent(parentsInfo.parents[1]),
    children: formatChildrens(
      childrensInfo.childrens,
      childrensInfo.childrensCount,
      parentsInfo.equalTimeParents
    )
  }

  return data;
}